import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import CartPage from './pages/CartPage';
import AdminPage from './pages/AdminPage';
import AdminLogin from './pages/AdminLogin';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { BcvProvider } from './context/BcvContext';
import { FloatingCheckoutButton } from './components/FloatingCheckoutButton';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BcvProvider>
      <CartProvider>
        <Router>
          <div className="min-h-screen app-background">
            <div className="app-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalogo" element={<CatalogPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
              <FloatingCheckoutButton />
              <Toaster position="top-right" />
            </div>
          </div>
        </Router>
      </CartProvider>
      </BcvProvider>
    </AuthProvider>
  );
}

export default App;
